import { Box, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import { c } from "@/theme/colorUtils";

export const PageRoot = styled(Box)`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const FormCard = styled(Stack)`
  width: 100%;
  gap: 4px
`;

export const FieldLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${c.text02};
  margin-bottom: 8px;
`;

export const HelperText = styled(Typography)`
  font-size: 0.75rem;
  color: ${c.text02};
`;

export const ErrorText = styled(Typography)`
  font-size: 0.75rem;
  color: ${c.error};
`;

